export default "__VITE_ASSET__BGfZfrrX__"